import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {config, settings} from './../config/config';
import Loader from '../components/loader';
import StatusInfo from '../components/status';
import Alert from '../components/alert';
import axios from 'axios';

const styles = theme => ({
  heroUnit: {
    margin: "0 0 15px 0"
  },
  heroContent: {
    maxWidth: 600,
    margin: '0 auto',
    padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
      width: 1100,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  typography: {
    paddingLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary
  }
});

class Stats extends Component {

  constructor() {
    super();
    this.alertHandleClose = this.alertHandleClose.bind(this);
  }

  async componentDidMount() {
    try {
      const response = await axios.post(settings.url + "/getStat", null , config);
      if (response) {
        this.setState({isLoading:false,icon : response.data.icon, allData:response.data.result, userData: response.data.userData});
      }
    } catch(e) {
      this.setState({isLoading:false,data:[],isAlertOpen:true, alertErrorMessage: JSON.stringify(e)})
    }
  }

  state = {
    isLoading: true,
    allData: [],
    userData: {},
    isAlertOpen: false,
    alertErrorMessage: ""
  }

  alertHandleClose() {
    this.setState({isAlertOpen: false});
  }

  render() {
    const {classes} = this.props;

    return (<main>
        <Grid container={true}>
          <Grid item={true} xs={12}>
            <Paper className={classes.paper}>
              <Typography component="h4" variant="h4" className={classes.typography}>
                統計データ
              </Typography>
              {this.state.isLoading && <Loader isVisible={this.state.isLoading}/>}
              {!this.state.isLoading && <StatusInfo allData={this.state.allData} userData={this.state.userData} />}
            </Paper>
            <Paper className={classes.paper}>
              *総ユーザー数は重複するユーザーもカウントされています。
            </Paper>
          </Grid>
        </Grid>
        <Alert open={this.state.isAlertOpen} handleClose={this.alertHandleClose} errorMessage={this.state.alertErrorMessage}/>
    </main>)
  }
}

Stats.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Stats);
